export enum StatisticsTypes {
  ROUTING_ATTEMPTS = 'SOURCE_CALL_1ST_ROUTING_ATTEMPTS',
  ALTERNATIVE_ATTEMPTS = 'SOURCE_CALL_ATLTERNATIVE_ROUTING_ATTEMPTS',
  UNSUCCESSFUL_ROUTES = 'SOURCE_CALL_FAILED_ROUTING_ATTEMPTS',
  DROP_ROUTING_REQUEST = 'SOURCE_CALL_DROP_ROUTING_REQUEST',
  DESTINATION_NOT_ROUTABLE = 'SOURCE_CALL_DISCARD_ROUTING_ATTEMPTS',
  DESTINATION_CALL = 'DESTINATION_CALL',
  TRANSIENT_CALL = 'TRANSIENT_CALL',
  ROUTING_FIRST_MATCH = 'ROUTING_RULE_ACTION_1ST_MATCH',
  ROUTING_SECOND_MATCH = 'ROUTING_RULE_ACTION_2ND_MATCH',
  ROUTING_THIRD_MATCH = 'ROUTING_RULE_ACTION_3RD_MATCH',
  ROUTING_RULE_ATTEMPTS = 'ROUTING_RULE_ACTION_TRY',
  ROUTING_RULE_FAILURES = 'ROUTING_RULE_ACTION_FAIL',
  NO_MATCH_RULE = 'NO_MATCH_RULE',
  HITS = 'HITS',
  SESSION_COUNT_AVERAGE = 'SESSION_COUNT_AVERAGE',
  SESSION_COUNT_MIN = 'SESSION_COUNT_MIN',
  SESSION_COUNT_MAX = 'SESSION_COUNT_MAX',
  REGISTRATION_ROUTED = 'REGISTRATION_ROUTED',
  REGISTRATION_UNROUTED = 'REGISTRATION_UNROUTED',
  REGISTRATION_BLOCKED = 'REGISTRATION_BLOCKED'
}
